import { render } from "./SproogyComponent.vue?vue&type=template&id=0f6608a8&scoped=true&ts=true"
import script from "./SproogyComponent.vue?vue&type=script&lang=ts"
export * from "./SproogyComponent.vue?vue&type=script&lang=ts"

import "./SproogyComponent.vue?vue&type=style&index=0&id=0f6608a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6608a8"]])

export default __exports__